import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';
import type IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';

import {
  BENEFICIARY_MOVEMENT_STATUS_NAME,
  BeneficiaryMovementStatusEnum,
} from '@constants';

import { Container, IconStyled, Label } from './style';

export const MovementEnumValues: {
  [statusType: string]: {
    icon?: IconNames;
    name: string;
    color: string;
    background: string;
    size?: number;
  };
} = {
  [BeneficiaryMovementStatusEnum.PROCESSED]: {
    icon: 'actions-b2b-check-circle',
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.PROCESSED
    ],
    color: NEW_COLORS.SEMANTICS.SUCCESS[500],
    background: NEW_COLORS.SEMANTICS.SUCCESS[50],
  },
  [BeneficiaryMovementStatusEnum.PROCESSING]: {
    icon: 'actions-b2b-timer',
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.PROCESSING
    ],
    color: NEW_COLORS.PRIMARY[600],
    background: NEW_COLORS.PRIMARY[50],
    size: 22,
  },
  [BeneficiaryMovementStatusEnum.UNPROCESSED]: {
    icon: 'medical-b2b-contract-cancel',
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.UNPROCESSED
    ],
    color: NEW_COLORS.GRAYSCALE[700],
    background: NEW_COLORS.GRAYSCALE[100],
  },
  [BeneficiaryMovementStatusEnum.REVIEWED]: {
    icon: 'actions-b2b-warning',
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.REVIEWED
    ],
    color: NEW_COLORS.SEMANTICS.ERROR[600],
    background: NEW_COLORS.SEMANTICS.ERROR[50],
  },
  [BeneficiaryMovementStatusEnum.CANCELED]: {
    icon: 'actions-b2b-close',
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.CANCELED
    ],
    color: NEW_COLORS.SEMANTICS.ERROR[500],
    background: NEW_COLORS.SEMANTICS.ERROR[50],
  },
  [BeneficiaryMovementStatusEnum.CANCELING]: {
    name: BENEFICIARY_MOVEMENT_STATUS_NAME[
      BeneficiaryMovementStatusEnum.CANCELING
    ],
    color: NEW_COLORS.SECONDARY[500],
    background: NEW_COLORS.SECONDARY[50],
  },
};

interface StatusTypeProps {
  statusType: string;
}

const StatusMovementLife = ({ statusType }: StatusTypeProps) => {
  return (
    <Container
      color={MovementEnumValues[statusType]?.color}
      background={MovementEnumValues[statusType]?.background}
    >
      <IconStyled
        name={MovementEnumValues[statusType]?.icon as IconNames}
        color={MovementEnumValues[statusType]?.color}
        size={MovementEnumValues[statusType]?.size ?? 18}
      />
      <Label color={MovementEnumValues[statusType]?.color}>
        {MovementEnumValues[statusType]?.name ?? '-'}
      </Label>
    </Container>
  );
};

export default StatusMovementLife;
